import React, {useEffect} from "react";
import ReactSeamlessScroll from "react-seamless-scroll";
import "../style/date.css";

const TablePlay = (props) => {
  const { subData } = props;
  return (
    <tr>
      <td className="rank">
        <p>
          <span>{subData.rank}</span>
        </p>
      </td>
      <td>{subData.number}</td>
      <td>{subData.name}</td>
      <td>{subData.totalSubScore}</td>
      <td>{subData.company}</td>
    </tr>
  );
};

const Broadcast = React.memo((props) => {
  const { playData } = props
  
  // useEffect(() => {
  //   if(playData && playData.length < 7 ) {
  //     // playData && playData.push(...playData.slice(3))
  //     return(playData && playData.push(...playData.slice(3)))
  // }
  // })

  // playData && playData.length < 7 ? playData.push(...playData.slice(3)) : playData

  playData && playData.push(...playData.slice(3))
  // console.log(playData, '数组');
    
    // if(playData && playData.length < 7 ) {
    //   playData.push(...playData.slice(3))
    //     // return(playData && playData.push(...playData.slice(3)))
    // }
  //   const fun = (playData) => {
  //     if(!playData) return
  //     if(playData.length < 7){
  //       console.log(playData,'------------------------');
  //       playData.push(...playData.slice(3))
  //     }
  //     return playData
  //   }
  // let data = []
  // useEffect(()=>{
  //   data = playData && fun(playData)
  // },[])
  
  return (
    <ReactSeamlessScroll>
      <table className="table-play">
        <tbody>
            {/* {console.log(data, '数组')} */}
          {
              (playData || []).slice(3).map((item) => (
              <TablePlay subData={item} key={item.rank+Math.random()} />
            ))
          }
        </tbody>
      </table>
    </ReactSeamlessScroll>
  );
});

export default Broadcast;
